import { OptionInput } from '@/types/schema';

export const getEmptyOption = (): OptionInput => ({
  optionText: '',
  optionEvaluation: false,
});
